import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import { Button } from 'react-bootstrap'
import classNames from 'classnames'

import '../../../assets/sass/components/images/custom-dropzone.scss'

class DropZone extends Component {

    static defaultProps = {
        onChange: console.log,
        className: 'custom-dropzone',
        accept: 'image/jpeg, image/png',
        title: 'Drag a profile photo here',
        dividerText: 'OR',
        dividerProps: {},
        buttonText: 'Select from Device',
        buttonProps: {}
    }

    render() {
        return (
            <>
                {this.wrapWithDropzone(this.renderContent())}
            </>
        )
    }

    wrapWithDropzone = (content) => {
        const { className, accept, onChange } = this.props;

        return (
            <Dropzone onDrop={onChange}>
                {({ getRootProps, getInputProps }) => {
                    return (
                        <div {...getRootProps({ className: classNames('dropzone', className) })}>
                            <input {...getInputProps()} accept={accept} />
                            {content}
                        </div>
                    );
                }}
            </Dropzone>
        )
    }

    renderContent = () => {
        return (
            <>
                {this.renderTitle()}
                {this.renderDivider()}
                {this.renderButton()}
            </>
        )
    }

    renderTitle = () => {
        const { title } = this.props;

        return (
            <p className="text">{title}</p>
        )
    }

    renderButton = () => {
        const { buttonText, buttonProps } = this.props;

        return (
            <Button
                variant="secondary"
                type="button"
                className="lg"
                {...buttonProps}
            >{buttonText}</Button>
        )
    }

    renderDivider = () => {
        const { dividerText, dividerProps } = this.props;

        return (
            <div className="divider-with-circle" {...dividerProps}>{dividerText}</div>
        )
    }
}

export default DropZone
